const ActivityTypeEnum = {
  skill: 'SKILL',
  checkpoint: 'CHECKPOINT',
  liveTraining: 'LIVE_TRAINING'
};

export { ActivityTypeEnum };
export default ActivityTypeEnum;
